import {createSelector} from 'reselect'
import {State} from 'lib/store'
import {ProgressState} from 'lib/progress'

const selectProgressFeature = (state: State): ProgressState => state.progress

export const isLoading = createSelector(selectProgressFeature, progress => progress.loading)
export const isProcessing = createSelector(selectProgressFeature, progress => progress.processing)